import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from "vue";
import { unref as _unref, renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = ["aria-label", "aria-hidden"];
import { ElPopover } from "element-plus";
import 'element-plus/es/components/popover/style/css'

import { useAttrs, useSlots } from "vue";
export default /* @__PURE__ */ _defineComponent({
  __name: "IMenu",
  props: /* @__PURE__ */ _mergeModels({
    hasUnderline: { type: Boolean }
  }, {
    "modelValue": { type: Boolean },
    "modelModifiers": {}
  }),
  emits: ["update:modelValue"],
  setup(__props) {
    const isShow = _useModel(__props, "modelValue");
    const attrs = useAttrs();
    const slots = useSlots();
    const title = attrs.title || attrs["aria-label"];
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(_unref(ElPopover), _mergeProps({
        visible: isShow.value,
        "onUpdate:visible": _cache[0] || (_cache[0] = ($event) => isShow.value = $event),
        trigger: "click",
        "hide-after": 0
      }, _unref(attrs)), {
        reference: _withCtx(() => [
          _createElementVNode("button", {
            type: "button",
            class: _normalizeClass([_ctx.hasUnderline && _ctx.$style.underline]),
            "aria-label": _unref(title),
            "aria-hidden": !_unref(slots).link
          }, [
            _renderSlot(_ctx.$slots, "link")
          ], 10, _hoisted_1)
        ]),
        default: _withCtx(() => [
          _cache[1] || (_cache[1] = _createTextVNode()),
          _renderSlot(_ctx.$slots, "menu")
        ]),
        _: 3,
        __: [1]
      }, 16, ["visible"]);
    };
  }
});
